import { filterNonNull } from "@zennya/web-component-library/src/components/SegmentIO";
import axios from "axios";
const API_URL = process.env.REACT_APP_WEB_ADMIN_URL;

const getServices = async ({ latitude, longitude, city=null, filter_items=false }) => {
  return (await axios.get(`${API_URL}/api/4/services`, {
    params: filterNonNull({
      latitude,
      longitude,
      city,
      filter_items: filter_items ? true: null
    })
  }))?.data;
};

const getWhitelabelServices = async ({ latitude, longitude, city, wlp_id, filter_items=false }) => {
  return (await axios.get(`${API_URL}/api/1/whitelabel/${wlp_id}/services`, {
    params: filterNonNull({
      latitude,
      longitude,
      city,
      filter_items: filter_items ? true: null
    })
  }))?.data;
};


const getFeaturedCategories = async ({ latitude, longitude }) => {
  const res = (await axios.get(`${API_URL}/api/1/featured_categories`, {
    params: filterNonNull({
      latitude,
      longitude,
      booking_version:5
    })
  }))?.data?.list ?? [];

  return res;
}

const getServicableAreas = async () => {
  return (await axios.get(`${API_URL}/api/1/cities/servicing`))?.data;
}
const getServiceDetails = async ({ serviceId, latitude=null, longitude=null, city=null }) => {
  return (await axios.get(`${API_URL}/api/1/services/${serviceId}/details`, {
    params: filterNonNull({
      latitude,
      longitude,
      city
    })

  }))?.data;
}

// v4 /details flattens each extended_package_item to
// { id, label, fee, description, icon_url, screening_service_code } — the
// screening_service_code is what drives whether a product needs screening.
// (The v1 /details above does not expose screening_service_code.)
const getServiceDetailsV4 = async ({ serviceId, latitude=null, longitude=null, city=null }) => {
  return (await axios.get(`${API_URL}/api/4/services/${serviceId}/details`, {
    params: filterNonNull({
      latitude,
      longitude,
      city
    })
  }))?.data;
}

// Metro-Manila regional-office fallback. The catalog is priced/seeded per
// regional office, so /details without coords returns an empty item list —
// pass a location (or this fallback) so cards render before the patient picks
// their real booking location.
const IV_FALLBACK_COORDS = { latitude: 14.5547, longitude: 121.0244 };

// Resolve the live IV-therapy catalog for the client IV pathway (ZO-11165):
// find the IV service type by name/label (never hard-code the id), then load
// its extended_package_items via the v4 /details.
const getIvCatalog = async ({ latitude = IV_FALLBACK_COORDS.latitude, longitude = IV_FALLBACK_COORDS.longitude } = {}) => {
  const servicesResp = await getServices({ latitude, longitude });
  const services = servicesResp?.services ?? servicesResp?.list ?? [];
  const ivType = services
    .map((s) => s?.type)
    .find((t) => {
      const name = (t?.name || "").toLowerCase();
      const label = (t?.label || "").toLowerCase();
      return name.includes("iv_therapy") || label.includes("intravenous") || /\biv\b/.test(label);
    });
  if (!ivType?.id) return { serviceTypeId: null, items: [] };
  const details = await getServiceDetailsV4({ serviceId: ivType.id, latitude, longitude });
  const items =
    details?.extended_package_items ??
    details?.serviceCategory?.extended_package_items ??
    [];
  return { serviceTypeId: ivType.id, items };
}

export {
  getServicableAreas,
  getServices,
  getFeaturedCategories,
  getServiceDetails,
  getServiceDetailsV4,
  getIvCatalog,
  IV_FALLBACK_COORDS,
  getWhitelabelServices
}